// src/components/CompanyPage/BackgroundCacheMonitor.tsx
import { useTrackCompanyPageCache } from '@/hooks/useTrackCompanyPageCache'
import { CompanyPageCachingTrackingItem } from '@/constants/company_page'
import { useCompanyPageStore } from '@/store/companyPageStore'

interface BackgroundCacheMonitorProps {
  item: CompanyPageCachingTrackingItem
}

const BackgroundCacheMonitor: React.FC<BackgroundCacheMonitorProps> = ({ item }) => {
  const { lang } = useCompanyPageStore()
  const { isCachingComplete: _isComplete } = useTrackCompanyPageCache({
    messageId: item.messageId,
    quarter: item.quarter,
    year: item.year,
    enabled: true, // 항상 활성화
    lang,
    onComplete: () => {},
  })

  return null
}

export default BackgroundCacheMonitor
